/**
 * @Description: 接口地址
 */
export default {
    LOGIN_API_URL: '/user/login', // 快速登陆
    VERIFICATION_CODE_API_URL: '/verification-code/getImage', // 图形验证码
    SMS_SEND_API_URL: '/sms/send', // 发送验证码
    // 专栏栏目API
    COLUMN_GET_API_URL: '/column/get',
    COLUMN_PAGE_API_URL: '/column/page',
    // 律师信息API
    LAWYER_GET_API_URL: '/lawyer/get',
    LAWYER_PAGE_API_URL: '/lawyer/page',
    // 文章新闻API
    NEWS_GET_API_URL: '/news/get',
    NEWS_PAGE_API_URL: '/news/page',
    NEWS_PDF_API_URL: 'http://49.233.45.92:8090/news/pdf?content=',
    // 首页BannerAPI
    INDEXPIC_PAGE_API_URL: '/index_pic/page',
    // 模糊列表
    LIKE_SEARCH_API_URL: '/news/likeSearch',
    // 活动弹窗API
    ARTICLE_AD_GET_API_URL: '/article_ad/get',
    ARTICLE_AD_PAGE_API_URL: '/article_ad/page'
}